export enum ProjectCompareTypes {
  comparator,
  reference,
}
